import { AppLanguage, getPreferredLanguage } from '../language';

export interface LabelingI18nTemplate {
  landing: {
    title: string;
    description: string;
    primaryAction: string;
  };
  nav: {
    purchase: string;
    orders: string;
  };
}

export const TEMPLATES: Record<AppLanguage, LabelingI18nTemplate> = {
  zh: {
    landing: {
      title: '海外快递',
      description:
        '提供中美双向快递服务，支持 Fedex, UPS, USPS 等多家物流公司比价下单。一键获取最优运费，让跨境物流更简单。',
      primaryAction: '立即下单',
    },
    nav: {
      purchase: '购买',
      orders: '订单',
    },
  },
  en: {
    landing: {
      title: 'Overseas Express',
      description:
        'Provide two-way China-US shipping with FedEx, UPS, USPS and more. Compare rates and place orders in one place.',
      primaryAction: 'Place Order',
    },
    nav: {
      purchase: 'Purchase',
      orders: 'Orders',
    },
  },
};

export const LABELING_NAMESPACE = 'labeling';

export const LABELING_RESOURCE_KEY = 'template';

export const LABELING_I18N_RESOURCES: Record<
  AppLanguage,
  Record<typeof LABELING_RESOURCE_KEY, LabelingI18nTemplate>
> = {
  zh: {
    [LABELING_RESOURCE_KEY]: TEMPLATES.zh,
  },
  en: {
    [LABELING_RESOURCE_KEY]: TEMPLATES.en,
  },
};

export const getLabelingTemplate = (
  language: AppLanguage = getPreferredLanguage(),
): LabelingI18nTemplate => TEMPLATES[language] || TEMPLATES.zh;
